import { render, staticRenderFns } from "./small-loader.vue?vue&type=template&id=783cc073"
import script from "./small-loader.vue?vue&type=script&lang=js"
export * from "./small-loader.vue?vue&type=script&lang=js"
import style0 from "./small-loader.vue?vue&type=style&index=0&id=783cc073&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports